import MainLayout from "../layouts/MainLayout";
import Header from "../components/home/Header";
import About from "../components/home/About";
import Projects from "../components/home/Projects";
import Contact from "../components/home/Contact";
import Skills from "../components/home/Skills";

const Home = () => {
    return (
        <MainLayout>
            <Header />
            <Skills />
            <About />
            <Projects />
            <Contact />
        </MainLayout>
    )
}

export default Home